import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

export default function DirectRedirect() {
  const location = useLocation();
  const [fallbackVisible, setFallbackVisible] = useState(false);

  // Parse UTM params from URL
  const searchParams = new URLSearchParams(location.search);
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const utm_campaign = searchParams.get("utm_campaign");

  const redirectToPage = () => {
  // Build query string if UTM params exist
  const query = new URLSearchParams();
  if (utm_source) query.append("utm_source", utm_source);
  if (utm_medium) query.append("utm_medium", utm_medium);
  if (utm_campaign) query.append("utm_campaign", utm_campaign);
  const queryString = query.toString() ? `?${query.toString()}` : "";

  // App deep links
  const iosAppLink = `esimliveconsumerapp://open/${queryString}`;

  // Store links
  const iosStoreLink =
    "https://apps.apple.com/us/app/esimlive-esim-travel-internet/id6478738851";
  const androidPackageName = "com.alienics";

  // Web fallback
  const webLink = `https://esimlive.com/${queryString}`;

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    // iOS: try app first, then fallback to App Store
    window.location.href = iosAppLink;
    setTimeout(() => {
      setFallbackVisible(true);
      window.location.href = iosStoreLink;
    }, 2000);
  } else if (/android/i.test(userAgent)) {
    const androidStoreLink = `https://play.google.com/store/apps/details?id=${androidPackageName}`;

    // Android: use intent:// deep link to auto-open app or Play Store
    const androidIntentLink = `intent://${queryString}#Intent;scheme=esimliveconsumerapp;package=${androidPackageName};S.browser_fallback_url=${encodeURIComponent(androidStoreLink)};end`;

    window.location.href = androidIntentLink;
  } else {
    // Web fallback
    window.location.href = webLink;
  }
};


  useEffect(() => {
    console.log("asdad");
    redirectToPage();
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Redirecting...</h2>
      <p style={styles.text}>Please wait while we open the app.</p>
      <div style={styles.loader}></div>
      {fallbackVisible && (
        <div style={styles.fallback}>
          <p>If the app didn’t open, you can continue here:</p>
          <a
            href={`https://esimlive.com/${utm_source ? `?utm_source=${utm_source}` : ""}`}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            Open in Browser
          </a>
        </div>
      )}
    </div>
  );
}

// Inline styles
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    fontFamily: "sans-serif",
    textAlign: "center",
    padding: "20px",
  },
  heading: { fontSize: "24px", marginBottom: "10px" },
  text: { fontSize: "16px", marginBottom: "20px", color: "#555" },
  loader: {
    width: "40px",
    height: "40px",
    border: "4px solid #ddd",
    borderTop: "4px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "20px",
  },
  fallback: { marginTop: "20px" },
  link: {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "6px",
    textDecoration: "none",
    marginTop: "10px",
  },
};
